import type { FC } from "react";
import { useEffect } from "react";
import type { RegisterOptions } from "react-hook-form";
import { Controller, useFormContext } from "react-hook-form";

import { Checkbox } from "@jti/core-components/components/Checkbox";

import styles from "./FormCheckbox.module.scss";

type FormCheckboxProps = {
  id: string;
  label: string;
  isCheckedByDefault?: boolean;
  validationRules: RegisterOptions;
  dataTestId?: string;
};

export const FormCheckbox: FC<FormCheckboxProps> = ({
  id,
  label,
  isCheckedByDefault,
  validationRules,
  dataTestId = "formCheckbox",
}) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    if (isCheckedByDefault !== undefined) {
      setValue(id, { checked: isCheckedByDefault });
    }
  }, [id, isCheckedByDefault, setValue]);

  return (
    <div className={styles.container}>
      <Controller
        name={id}
        defaultValue={{ checked: isCheckedByDefault ?? false }}
        rules={{
          validate: (value?: { checked: boolean }) => (validationRules.required ? !!value?.checked : true),
        }}
        render={({ field, fieldState: { error } }) => (
          <Checkbox
            required={!!validationRules.required}
            checked={field.value?.checked ?? false}
            name={field.name}
            onBlur={field.onBlur}
            onCheckedChange={(checked) => {
              field.onChange({ checked });
            }}
            id={id}
            label={label}
            status={error ? "error" : "default"}
            errorMessage={error?.message}
            data-testid={dataTestId}
            ref={field.ref}
          />
        )}
      />
    </div>
  );
};
